import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Control } from "react-hook-form";

import { getFile } from "../../api/file/getFile";
import InfoButton from "../../components/buttons/InfoButton";
import APCheckbox from "../../components/form/APCheckbox";
import { PersonaliseQuoteInputs } from "../../helpers/quotes";

const VehicleOptionCard = ({
  id,
  catchEOptionId,
  label,
  price,
  imageUrl,
  control,
  showImage,
  hasHighlight,
  handleHighlightClick,
  isInclusion = false,
  disableCheckbox = false,
}: {
  id: string;
  catchEOptionId: string;
  label: string;
  price?: string;
  control?: Control<PersonaliseQuoteInputs>;
  showImage: boolean;
  imageUrl?: string | null;
  hasHighlight?: boolean;
  handleHighlightClick?: (optionId: string) => void;
  isInclusion?: boolean;
  disableCheckbox?: boolean;
}) => {
  const renderedPrice = price ? (
    <Typography variant="bodySmall">{price}</Typography>
  ) : null;

  const imageSrc = getFile(imageUrl || "", true, { disabled: !imageUrl });

  let _imageSrc: string | null;

  if (imageSrc.data) {
    _imageSrc = imageSrc.data;
  } else if (imageSrc.isIdle) {
    _imageSrc = "/photo-placeholder.png";
  } else {
    _imageSrc = null;
  }

  return (
    <Box>
      {_imageSrc && (
        <Card
          sx={{
            display: "flex",
            backgroundColor: "surface.main",
          }}
          variant="outlined"
        >
          {control && (
            <Box sx={{ p: 1, py: imageUrl ? 1 : 2 }}>
              <APCheckbox
                name={
                  isInclusion
                    ? `inclusions.${catchEOptionId}`
                    : `options.${catchEOptionId}`
                }
                defaultValue={false}
                control={control}
                disabled={disableCheckbox}
              />
            </Box>
          )}
          <CardActionArea
            sx={{ display: "flex", py: imageUrl ? 0 : 1 }}
            onClick={() => handleHighlightClick && handleHighlightClick(id)}
            disabled={!hasHighlight}
          >
            {showImage && _imageSrc && (
              <CardMedia
                component="img"
                sx={{ height: "7.5rem", width: "7.5rem" }}
                image={_imageSrc}
                alt={`${label}`}
              />
            )}
            <Box
              sx={{
                p: 1,
                pr: 2,
                height: _imageSrc ? "100%" : "initial",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="titleMedium">{label}</Typography>
                {hasHighlight ? <InfoButton /> : renderedPrice}
              </Box>
              {hasHighlight && renderedPrice && (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  {renderedPrice}
                </Box>
              )}
            </Box>
          </CardActionArea>
        </Card>
      )}
    </Box>
  );
};

export default VehicleOptionCard;
